import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery, Chip } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import DataTable, { Column, RowAction } from '../components/DataTable';
import BulkImportSummaryModal from '../components/BulkImportSummaryModal';
import BulkUploadListsModal from '../components/BulkUploadListsModal';
interface BulkUploadListsProps {
  onLogout: () => void;
}
interface UploadBatch {
  id: number;
  fileId: string;
  batchId: string;
  fileName: string;
  dataRows: number;
  uploadedDateTime: string;
}
const MOCK_BATCHES: UploadBatch[] = [{
  id: 1,
  fileId: 'FILE-001',
  batchId: 'BATCH-001',
  fileName: 'branch_records_jan_2025.xlsx',
  dataRows: 150,
  uploadedDateTime: new Date('2025-01-15T10:30:00').toISOString()
}, {
  id: 2,
  fileId: 'FILE-002',
  batchId: 'BATCH-002',
  fileName: 'new_records_batch_2.xlsx',
  dataRows: 75,
  uploadedDateTime: new Date('2025-01-14T14:20:00').toISOString()
}, {
  id: 3,
  fileId: 'FILE-003',
  batchId: 'BATCH-003',
  fileName: 'record_upload_q1.xlsx',
  dataRows: 200,
  uploadedDateTime: new Date('2025-01-13T09:15:00').toISOString()
}];
export default function BulkUploadLists({
  onLogout
}: BulkUploadListsProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [batches] = useState<UploadBatch[]>(MOCK_BATCHES);
  const [selectedBatch, setSelectedBatch] = useState<UploadBatch | null>(null);
  const [listModalOpen, setListModalOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleViewList = (batch: UploadBatch) => {
    setSelectedBatch(batch);
    setListModalOpen(true);
  };
  const handleCloseListModal = () => {
    setListModalOpen(false);
    setSelectedBatch(null);
  };
  const columns: Column<UploadBatch>[] = [{
    id: 'fileId',
    label: 'File ID'
  }, {
    id: 'batchId',
    label: 'Batch ID'
  }, {
    id: 'fileName',
    label: 'File Name'
  }, {
    id: 'dataRows',
    label: 'Data Rows',
    renderCell: row => <Chip label={row.dataRows} size="small" sx={{
      backgroundColor: 'rgba(6, 182, 212, 0.1)',
      color: '#06B6D4',
      fontWeight: 600
    }} data-id="element-3150" data-mp="296doqowl6ybx" />
  }, {
    id: 'uploadedDateTime',
    label: 'Uploaded Date & Time',
    renderCell: row => new Date(row.uploadedDateTime).toLocaleString()
  }];
  const rowActions: RowAction<UploadBatch>[] = [{
    icon: 'lucide:file-text',
    label: 'Summary',
    onClick: handleViewList
  }];
  return <Box sx={{
    width: '100%',
    height: '100%',
    bgcolor: 'background.default'
  }} data-id="element-3151" data-mp="3kmkdesf9v3s1">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-3152" data-mp="3s6mjsuwxqdm1" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="bulk-upload-lists" data-id="element-3153" data-mp="3s48pwpdzr7g2" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      width: {
        xs: '100%',
        sm: `calc(100% - ${240}px)`
      },
      ml: {
        xs: 0,
        sm: `${240}px`
      },
      mt: 8
    }} data-id="element-3154" data-mp="5pywg1v7f98f">
        <Container maxWidth="xl" data-id="element-3155" data-mp="3e5sckflmiioy">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-3156" data-mp="3e8ekigcff07p">
            <Grid item xs={12} data-id="element-3157" data-mp="3o5ja6q5hddt9">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-3158" data-mp="3o2euavinktmr">
                <Icon icon="lucide:file-text" width={24} height={24} color="#0EA5E9" data-id="element-3159" data-mp="13dhczyv3xfmz" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-3160" data-mp="wya5j8c1e7g6">
                  Bulk Upload Lists
                </Typography>
              </Box>
            </Grid>
          </Grid>
          {/* Batches Table */}
          <DataTable title="Upload Batches" data={batches} columns={columns} rowActions={rowActions} keyField="id" initialVisibleColumns={['fileId', 'batchId', 'fileName', 'dataRows', 'uploadedDateTime']} emptyStateMessage="No upload batches found" data-id="element-3161" data-mp="1jwdetoed79sy" />
          {/* List Modal */}
          {selectedBatch && <BulkUploadListsModal open={listModalOpen} onClose={handleCloseListModal} batch={selectedBatch} data-id="element-3162" data-mp="1yp74g2ncp6bc" />}
        </Container>
      </Box>
    </Box>;
}